import type {PaymentUpdateView} from '../dtos/payment-plan-update';

// Live mounted surfaces only: no persistent cache can leak a previous tenant/session's data.
type Listener = (view: PaymentUpdateView, source: object) => void;
const listeners = new Map<string, Set<Listener>>();
export function subscribePaymentUpdate(caseUid: string, listener: Listener): () => void {
	const group = listeners.get(caseUid) ?? new Set<Listener>();
	group.add(listener); listeners.set(caseUid, group);
	return () => {group.delete(listener); if (!group.size) listeners.delete(caseUid);};
}
export function publishPaymentUpdate(caseUid: string, view: PaymentUpdateView, source: object): void {
	listeners.get(caseUid)?.forEach(listener => listener(view, source));
}
